import React from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const BrokerLimitModal = ({ open, onClose, allowedCount }) => {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    onClose();
    navigate("/pricing");
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", backgroundColor: "#1677FF" }}>
          <div className="icon-glow warning">
            <AlertTriangle size={38} />
          </div>
          <div style={{ marginTop: "8px", fontSize: "20px", fontWeight: 600 }}>
            Broker Limit Reached
          </div>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="pricing" type="primary" onClick={handleViewPlans}>
          Upgrade Plan
        </Button>
      ]}
      className="sub-req-modal"
    >
      <p style={{ fontSize: "16px", marginBottom: "8px" }}>
        You can enable only <b>{allowedCount}</b> broker account(s) at a time.
      </p>
      <p style={{ fontSize: "14px", color: "#666" }}>
        Purchase an add-on plan to enable more brokers simultaneously.
      </p>
    </Modal>
  );
};

export default BrokerLimitModal;
